import React, { useState } from "react";
import casestudy from "../../assets/FlipImages/1.png";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import global from '../../assets/images/blogs/Global-Expansion-1.png'

const GlobalExpansion = () => {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [comments, setComments] = useState([]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWebsiteChange = (event) => {
    setWebsite(event.target.value);
  };

  const handleSaveInfoChange = (event) => {
    setSaveInfo(event.target.checked);
  };

  const handleCommentSubmit = () => {
    if (comment.trim() && name.trim() && email.trim()) {
      setComments([...comments, { comment, name, email, website }]);
      setComment("");
      setName("");
      setEmail("");
      setWebsite("");
      setSaveInfo(false);
    }
  };

  return (
    <>
      <style jsx>{`
        h4 {
          font-size: 18px;
        }
        h3 {
          font-size: 28px;
        }
        span {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
        li {
          font-size: 16px;
          font-weight: 500;
        }
        .mainCard {
          height: 20rem;
        }
        .circle {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          overflow: hidden;
        }
        i {
          color: #072f5f;
        }
        ul {
          padding-left: 17px;
        }
        @media (max-width: 574px) {
          .mTop {
            margin-top: 30px;
          }
          p {
            font-size: 18px;
          }
          .img-fluid {
            min-height: 100px;
          }
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (min-width: 992px) {
          /* for banner image */
          .bmTop {
            margin-top: 130px;
          }
        }
        @media (max-width: 574px) {
          .banner-image {
            margin-top: 70px; /* Adjust this value for mobile view */
          }
        }
      `}</style>

      <section className="">
        <div
          className="d-flex justify-content-center align-items-center banner-image"
          style={{
            background: `url(${casestudy}) no-repeat center`,
            backgroundSize: "cover",
            height: "200px",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3
              className="text-white text-uppercase text-center"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Global Expansion? Here's Why Your Business Needs <br/> an International CPA Outsourcing Partner.
            </h3>
          </div>
        </div>
        <div className="container-fluid">
          <div
            className="d-flex row justify-content-center align-items-start"
            style={{ gap: "2rem" }}
          >
            <div
              className="col-lg-8 mt-50 mb-50 border shadow"
              style={{ padding: "2rem" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                  <div
                    style={{
                      background: "#072f5f",
                      display: "inline",
                      width: "fit-content",
                      padding: "0.2rem 1rem 0.2rem 1rem",
                    }}
                  >
                    <small
                      className="text-uppercase text-white"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Introduction
                    </small>
                  </div>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      ></span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      As businesses increasingly look beyond domestic borders
                      for growth opportunities, the complexity of managing
                      international finances has never been greater. Whether
                      you're a startup eyeing overseas markets or an established
                      company expanding globally, partnering with an
                      international CPA outsourcing firm can be the difference
                      between successful expansion and costly compliance
                      mistakes.
                    </p>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        The Hidden Challenges of International Business Finance
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Global expansion brings exciting opportunities, but it
                      also introduces a maze of financial complexities that can
                      overwhelm even experienced finance teams. International
                      tax compliance, multi-currency accounting, and varying
                      regulatory requirements across different countries create
                      a perfect storm of challenges that require specialized
                      expertise.
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Consider this: each country has unique tax laws, reporting
                      standards, and filing deadlines. What works for your U.S.
                      operations may be completely inadequate—or even illegal—in
                      your target markets. This is where outsourced accounting
                      services with international expertise become invaluable.{" "}
                    </p>

                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Why International CPA Outsourcing Makes Strategic Sense{" "}
                      </span>
                    </div>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        Cost-Effective Expertise : Hiring full-time
                        international tax specialists for every target market is
                        prohibitively expensive for most businesses. CPA
                        outsourcing allows you to access world-class expertise
                        without the overhead of maintaining a large in-house
                        team. This approach can reduce your accounting costs by
                        up to 50% while providing superior expertise.
                      </li>
                      <li>
                        Compliance Confidence : International tax compliance
                        mistakes can result in hefty penalties, legal issues,
                        and damaged business relationships. Professional
                        outsourced CPA services ensure your business stays
                        compliant with local regulations, from VAT requirements
                        in Europe to GST obligations in Australia.
                      </li>
                      <li>
                        Scalable Solutions : As your international presence
                        grows, your accounting needs evolve. Outsourced
                        accounting services provide the flexibility to scale up
                        or down based on your business requirements, without the
                        constraints of fixed staffing costs.
                      </li>
                    </ul>
                  </div>

                  <div className="mt-15">
                    <span
                      className="text-capitalize"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#002249",
                      }}
                    >
                      Key Services Your International CPA Partner Should Provide
                    </span>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    When selecting an international accounting firm, look for
                    comprehensive services including:
                  </p>

                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>• Multi-country tax preparation and filing</li>
                    <li>• Transfer pricing documentation</li>
                    <li>• International bookkeeping services</li>
                    <li>• Cross-border transaction support</li>
                    <li>• Foreign exchange management</li>
                    <li>• Regulatory compliance monitoring</li>
                  </ul>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        The Boston Financial Advantage
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      At Boston Financial, we understand that successful global
                      expansion requires more than just basic accounting
                      support. Our international CPA outsourcing services are
                      designed to be your strategic partner in navigating
                      complex global financial landscapes.{" "}
                    </p>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Our team of certified professionals brings deep expertise
                      in international tax laws, ensuring your business remains
                      compliant while optimizing your global tax strategy. From
                      small business accounting to complex multinational
                      corporation needs, we provide scalable solutions that grow
                      with your business.{" "}
                    </p>
                  </div>

                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Making the Right Choice for Your Business
                      </span>
                    </div>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    The decision to expand internationally shouldn't be
                    complicated by financial management concerns. With the right
                    CPA outsourcing partner, you can focus on what you do
                    best—growing your business—while experts handle the
                    complexities of international finance.
                  </p>
                   <img
                    src={global}
                    style={{
                      display: "block",
                      margin: "1rem auto",
                      width: "350px",
                      height: "270px",
                    }}
                  />
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Don't let accounting complexities slow your global
                    ambitions. Partner with Boston Financial's international CPA
                    outsourcing services and transform your expansion challenges
                    into competitive advantages.
                  </p>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Ready to take your business global? Contact Boston Financial
                    today to learn how our international accounting expertise
                    can support your expansion goals while ensuring compliance
                    and optimizing your financial operations.
                  </p>

                 
                
                  <Box
                    mt="2rem"
                    p="2rem"
                    border="1px solid #ddd"
                    borderRadius="8px"
                  >
                    <Typography variant="h5" gutterBottom>
                      Leave a Comment
                    </Typography>
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={comment}
                      onChange={handleCommentChange}
                      margin="normal"
                    />
                    <Box display="flex" gap="1rem">
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={handleNameChange}
                        margin="normal"
                      />
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={handleEmailChange}
                        margin="normal"
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={saveInfo}
                          onChange={handleSaveInfoChange}
                        />
                      }
                      label="Save my name, email, and website in this browser for the next time I comment."
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCommentSubmit}
                      style={{ backgroundColor: "rgb(0, 34, 73)" }}
                    >
                      Send Comment
                    </Button>
                  </Box>
                  <Box mt="2rem">
                    {comments.map((cmt, index) => (
                      <Box
                        key={index}
                        mt="1rem"
                        p="1rem"
                        border="1px solid #ddd"
                        borderRadius="8px"
                      >
                        <Typography variant="body1">{cmt.comment}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cmt.name} - {cmt.email}
                          {cmt.website && ` - ${cmt.website}`}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GlobalExpansion;
